/**
 * Page Performance — status and chart colours, from the app's own tokens
 * only (index.css), so both themes follow automatically.
 *
 * The app has no orange token, and "Slow" sits between Warning (amber) and
 * Critical (red); it is mixed from those two tokens rather than given a hex
 * of its own, so it moves with them in dark mode.
 *
 * Kept out of the component files so they export only components (React
 * Fast Refresh).
 */
export const STATUS_TONE = Object.freeze({
  healthy: 'var(--color-success)',
  warning: 'var(--color-warning)',
  slow: 'color-mix(in srgb, var(--color-warning) 45%, var(--color-danger))',
  critical: 'var(--color-danger)',
})

/** A neutral tone for "not judged" (no status from the server). */
export const NEUTRAL_TONE = 'var(--color-ink-subtle)'

export function toneOf(status) {
  return STATUS_TONE[status] ?? NEUTRAL_TONE
}

/** A soft tint of a tone for a badge or chip background. */
export function tintOf(tone, pct = 14) {
  return `color-mix(in srgb, ${tone} ${pct}%, transparent)`
}

/** The brand navy / cyan chart family (dashboards' palette). */
export const CHART = Object.freeze({
  p95: 'var(--color-accent)',
  avg: 'var(--color-mint)',
  loads: 'var(--color-accent)',
  restart: 'var(--color-ink-subtle)',
  grid: 'var(--color-rule)',
  axis: 'var(--color-ink-muted)',
  warning: 'var(--color-warning)',
  critical: 'var(--color-danger)',
})
